import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  :root {
    --bg-0: ${(p) => p.theme.color.bg[0]};
    --bg-1: ${(p) => p.theme.color.bg[1]};
    --bg-2: ${(p) => p.theme.color.bg[2]};
    --bg-3: ${(p) => p.theme.color.bg[3]};
    --bg-4: ${(p) => p.theme.color.bg[4]};
    --hover: ${(p) => p.theme.color.hover};

    --border-faint: ${(p) => p.theme.color.border.faint};
    --border-soft: ${(p) => p.theme.color.border.soft};
    --border-med: ${(p) => p.theme.color.border.med};
    --border-strong: ${(p) => p.theme.color.border.strong};

    --text-0: ${(p) => p.theme.color.text[0]};
    --text-1: ${(p) => p.theme.color.text[1]};
    --text-2: ${(p) => p.theme.color.text[2]};
    --text-3: ${(p) => p.theme.color.text[3]};
    --text-4: ${(p) => p.theme.color.text[4]};

    --amber: ${(p) => p.theme.color.accent.amber};
    --amber-bright: ${(p) => p.theme.color.accent.amberBright};
    --amber-dim: ${(p) => p.theme.color.accent.amberDim};
    --amber-glow: ${(p) => p.theme.color.accent.amberGlow};
    --amber-line: ${(p) => p.theme.color.accent.amberLine};

    --up: ${(p) => p.theme.color.semantic.up};
    --down: ${(p) => p.theme.color.semantic.down};
    --flat: ${(p) => p.theme.color.semantic.flat};

    --font-sans: ${(p) => p.theme.font.sans};
    --font-serif: ${(p) => p.theme.font.serif};
    --font-mono: ${(p) => p.theme.font.mono};
  }

  *, *::before, *::after { box-sizing: border-box; }

  html, body {
    margin: 0;
    padding: 0;
    background: var(--bg-0);
    color: var(--text-0);
    font-family: var(--font-sans);
    font-feature-settings: 'cv11', 'ss01';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a { color: inherit; text-decoration: none; }

  button {
    font-family: inherit;
    color: inherit;
    cursor: pointer;
  }

  ::selection {
    background: var(--amber);
    color: var(--bg-0);
  }
`;
